import React, { useEffect, useState } from "react";
import { useFetchAll } from "../../../../../custom/FetchApiHook";
import { TemplateApi } from "../../../../../App/api/setting";
import { toast } from "react-toastify";
import CustomTextEditor from "../../../../../custom/CustomTextEditor";

const DeliveryManTNC = () => {
  const { value: privacyData } = useFetchAll(() =>
    TemplateApi.privacyAndTerms.getCustomerPolicy()
  );

  const { _id } = privacyData?.data?.length > 0 ? privacyData?.data?.[0] : [];

  // console.log("id", _id);
  const [editorContent, setEditorContent] = useState("");

  // Fetch data and update editor content
  useEffect(() => {
    if (privacyData?.data?.length) {
      const { customerTermsAndConditions = "" } = privacyData.data[0];
      setEditorContent(customerTermsAndConditions);
    }
  }, [privacyData]);

  const createAndupdatePrivacy = async (value) => {
    const payload = { deliveryManTermsAndConditions: value };
    // console.log("value", value);

    try {
      if (_id) {
        const res = await TemplateApi.privacyAndTerms.updateCustomerPolicy(
          payload,
          _id
        );
        toast.success("Privacy Policy updated successfully");
      } else {
        const res = await TemplateApi.privacyAndTerms.customerPolicy(payload);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return (
    <div className="w-full rounded-md mx-auto p-5 bg-white">
      <div className="flex justify-between ">
        <h1 className="text-xl text-gray-600  font-bold">
          Customer Term & Conditions
        </h1>
        <button
          className="mb-5 text-white bg-[var(--color--2)] px-2 py-1 rounded-md"
          onClick={() => createAndupdatePrivacy(editorContent)}
        >
          {_id ? "Update" : "Add"}
        </button>
      </div>
      <CustomTextEditor
        editorContent={editorContent}
        setEditorContent={setEditorContent}
      />
    </div>
  );
};

export default DeliveryManTNC;
